import axios from "axios"
import {getField, updateField} from 'vuex-map-fields'
import moment from 'moment'
import i18n from '@/i18n'

const activeComplaint = function (state, editing) {
  return editing ? state.eComplaint : state.complaint
}

const defaultState = {
  step: 1, // 1/2/3/4
  editing: false, // false/step1_editing/step2_editing
  compensation: {
    amount: 0, // integer
    currency: '',
    amount_in_eur: 0,
    compensable: false,
    compensation_type: 0,
    errors: []
  },
  complaint: {
    source_origin: undefined,
    tduid: undefined,
    /* STEP 1 */
    //required/dropdown only
    departure_airport: {}, // {id: 4228, label: 'London (LHR) London Heathrow, United Kingdom', value: 'London (LHR)'}
    //required/dropdown only
    arrival_airport: {}, // {id: 2, label: 'Anaa (AAA) Anaa, French Polynesia', value: 'Anaa (AAA)'}
    //required/XXYYYY (AB0007) danger message(if not XXYYYY)
    flight_number: '', // FL1234
    next_flight_number: '',
    // required
    scheduled_arrival_at_ui_date_time: {
      hours: '00',
      minutes: '00'
    },
    //required
    kind: '', // delayed/cancelled/overbooked/corona/early
    //required
    delay: '-1', // 119/120/180/240/720
    //required
    reason: 4, // 11..21
    //required
    people: 1,
    is_comment: true, // true/false
    comment: '', // some text
    client_informed: '', // 0, 1, 2
    /* STEP 2 */
    //required
    name: '', // Jack London
    //required
    address: '', // 25 Magic street
    //required
    insurance_number: '', // GF12345678
    // required if insurance client
    zip_code: '', // 696969
    //required
    city: '', // Big Bam
    //set Macda::Country.for_customer_select (default based on domain)
    macda_country_id: 'DK', // 1..n
    //required/email type/confirmation
    email: '', // jlondon@gmail.com
    confirm_email: '', // jlondon@gmail.com
    /* STEP 3 */
    // required
    terms: false, // true/false
  },
  eComplaint: {},
  receipt: {
    id: '',
    authorization_key: '',
    domain: '',
    source_origin: '',
  },
  countriesCodes: []
}

const actions = {

  getCompensation(context) {
    return new Promise((resolve, reject) => {
      var sdta = context.state.complaint.scheduled_arrival_at_ui_date_time;
      var scheduled_date_arrival = sdta.year.toString() + "-" + sdta.month.toString() + "-" + sdta.date.toString();

      axios.get('/check_compensation', {
        params: {
          dep_apt_id: context.state.complaint.departure_airport.id,
          arr_apt_id: context.state.complaint.arrival_airport.id,
          kind:       context.state.complaint.kind,
          delay_time: context.state.complaint.delay,
          scheduled_arrival_at: scheduled_date_arrival,
          flight_number: context.state.complaint.flight_number, // obsolete, will remove after final decision is made
          currency: context.state.currency,
          next_flight_number: context.state.complaint.next_flight_number,
          source_origin: context.state.complaint.source_origin,
          client_informed: context.state.complaint.client_informed,
        }
      })
        .then(({data}) => {
          if (data.compensable == true) {
            context.commit('GET_COMMPENSATION_POSSIBLE', data)
            return resolve(data.amount)
          } else {
            context.commit('GET_COMMPENSATION_IMPOSSIBLE', data)
            return resolve(data.amount)
          }
        })
        .catch((error) => {
          return reject(error)
        })
    })
  },

  trackFormPageVisit(context) {
    return new Promise((resolve, reject) => {
      axios.get(document.location.origin + '/miscellaneous/tracking/facebook_api/',
        {
          params: {
            event_name:  'CustomizeProduct',
            page_path: window.location.pathname,
            content_id: context.state.step
          }
        }, 
        {headers: {'Content-Type': 'application/json'}
      }).then( ({data})=> {
        return data.success ? resolve(data) : reject(data)
      }).catch((errors) => {
        // should reject
        return resolve(errors)
      })
    })
  },

  trackFacebookSubmitApplication(context) {
    return new Promise((resolve, reject) => {
      axios.get(document.location.origin + '/miscellaneous/tracking/facebook_api/',
        {
          params: {
            event_name:  'SubmitApplication',
            page_path: window.location.pathname,
            content_id: context.state.receipt.id,
            currency: context.state.compensation.currency,
            value: context.state.compensation.amount,
            email: context.state.complaint.email,
            name: context.state.complaint.name,
            zip_code: context.state.complaint.zip_code,
            city: context.state.complaint.city,
            state: context.state.complaint.macda_country_id
          }
        },
        {headers: {'Content-Type': 'application/json'}
      }).then( ({data})=> {
        return data.success ? resolve(data) : reject(data)
      }).catch((errors) => {
        // should reject
        return resolve(errors)
      })
    })
  },

  trackFacebookLead(context) {
    return new Promise((resolve, reject) => {
      axios.get(document.location.origin + '/miscellaneous/tracking/facebook_api/',
        {
          params: {
            event_name:  'Lead',
            page_path: window.location.pathname,
            content_id: context.state.receipt.id,
            currency: context.state.compensation.currency,
            value: context.state.compensation.amount,
          }
        },
        {headers: {'Content-Type': 'application/json'}
      }).then( ({data})=> {
        return data.success ? resolve(data) : reject(data)
      }).catch((errors) => {
        // should reject
        return resolve(errors)
      })
    })
  },

  trackFacebookPurchase(context) {
    return new Promise((resolve, reject) => {
      axios.get(document.location.origin + '/miscellaneous/tracking/facebook_api/',
        {
          params: {
            event_name:  'Purchase',
            page_path: window.location.pathname,
            content_id: context.state.receipt.id,
            currency: context.state.compensation.currency,
            value: context.state.compensation.amount,
          }
        },
        {headers: {'Content-Type': 'application/json'}
      }).then( ({data})=> {
        return data.success ? resolve(data) : reject(data)
      }).catch((errors) => {
        // should reject
        return resolve(errors)
      })
    })
  },

  beforeClaimCompletedGoogle(context) {
    return new Promise((resolve) => {
      let claim_id = context.state.receipt.id
      let internal_tracking_url = 'https://api.flyforsinkelse.dk/update_gtm_internal/CBWxUx3mJfYtnDr3mY82grvggcQDpx/' + claim_id

      axios.get(internal_tracking_url, {
        params: {
          claim_id: claim_id,
          event: 'BEFORE'
        }
      }).then((data) => {
        resolve(data['status']);
      });
    })
  },

  afterClaimCompletedGoogle(context, response) {
    return new Promise((resolve) => {
      let claim_id = context.state.receipt.id
      let internal_tracking_url = 'https://api.flyforsinkelse.dk/update_gtm_internal/CBWxUx3mJfYtnDr3mY82grvggcQDpx/' + claim_id

     axios.get(internal_tracking_url, {
        params: {
          claim_id: claim_id,
          event: response
        }
      }).then((data) => {
        resolve(data['status']);
      });
    })
  },

  pushToDataLayer(context) {
    return new Promise((resolve) => {
      let total_claim_value = context.state.compensation.amount_in_eur * context.state.complaint.people * 0.31 * 0.25
      let claim_id = context.state.receipt.id
      let total_claim_persons = context.state.complaint.people
      let country = context.state.complaint.macda_country_id

      if (window['google_tag_manager'] !== undefined) {
        window.dataLayer.push({
          'event': 'claim_completed',
          'total_claim_value': total_claim_value,
          'claim_id': claim_id,
          'total_claim_persons': total_claim_persons,
          'country': country,
          'event_callback': function(id) {
            setTimeout(() => { resolve('SUCCESS to ' + id)}, 1000)
          },
          'event_timeout': 2000
        });
      } else {
        resolve('NOGTM')
      }
    })
  },

  claimCompletedUetq() {
    return new Promise((resolve) => {
      window.uetq = window.uetq || [];
      window.uetq.push('event', 'claim_completed', {"event_category":"claim_funnel","revenue_value":1,"currency":"DKK"});
      resolve('UETQ sent');
    })
  },

  submitFormTikTok() {
    return new Promise((resolve) => {
      if (window.ttq) {
        ttq.track('SubmitForm');
        resolve('TTQ sent');
      }
      resolve('NO TTQ found, not initialized')
    })
  },

  postComplaint(context) {
    return new Promise((resolve, reject) => {

      axios.post('/complaints', context.getters.r1ComplaintFormData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(({data}) => {
        return data.success ? resolve(data) : reject(data)
      }).catch((errors) => {
        return reject(errors)
      })

    })
  }
}

const mutations = {

  updateField,

  UPDATE_COMPLAINT_FIELD(state, payload){
    updateField(activeComplaint(state, state.editing), payload)
  },

  RESET_STORE(state) {
    Object.assign(state, defaultState)
  },

  NEXT_STEP(state) {
    if (state.step == 3) {
      let key = state.receipt.authorization_key
      window.location.href = window.location.origin + "/authorizations/" + key;
    }
    else if (state.step < 4) {
      state.step++
      state.editing = false
    }
  },

  PREV_STEP(state) {
    if (state.step > 1) {
      state.step--
      state.editing = false
    }
  },

  SET_SCHEDULED_ARRIVAL_AT_UI_DATE(state, payload){
    let {year, month, date} = payload
    activeComplaint(state, state.editing).scheduled_arrival_at_ui_date_time = {
      year: year,
      month: month,
      date: date,
      hours: state.complaint.scheduled_arrival_at_ui_date_time.hours,
      minutes: state.complaint.scheduled_arrival_at_ui_date_time.minutes
    }
  },

  SET_KIND(state, value) {
    const emptyInput = -1
    const otherReason = 14
    let reasonVal = (value == 'overbooked' || value == 'corona' || value == 'early') ? otherReason : state.complaint.reason
    activeComplaint(state, state.editing).kind = value
    activeComplaint(state, state.editing).reason = reasonVal
    activeComplaint(state, state.editing).delay = state.complaint.delay == emptyInput ? '' : state.complaint.delay
  },

  SET_CLIENT_INFORMED(state, value) {
    activeComplaint(state, state.editing).client_informed = value;
  },

  INCREMENT_PEOPLE(state) {
    if (activeComplaint(state, state.editing).people < 30) {
      activeComplaint(state, state.editing).people++
    }
  },

  DECREMENT_PEOPLE(state) {
    if (activeComplaint(state, state.editing).people > 1) {
      activeComplaint(state, state.editing).people--
    }
  },

  TOGGLE_COMMENT(state, value) {
    activeComplaint(state, state.editing).is_comment = value
    activeComplaint(state, state.editing).comment = ''
  },

  CLEAR_MISSED_FLIGHT(state) {
    activeComplaint(state, state.editing).next_flight_number = ''
  },

  SET_UNCOMPENSABLE_DELAY(state, value) {
    if (value == 3) {
      activeComplaint(state, state.editing).delay = -1
    } else {
      activeComplaint(state, state.editing).delay = ''
    } 
  },

  GET_COMMPENSATION_POSSIBLE(state, payload) {
    console.log(payload)
    let {currency, amount, amount_in_eur, which_law, compensable, compensation_type} = payload
    state.compensation.amount_in_eur = amount_in_eur
    state.compensation.amount = amount
    state.compensation.currency = currency
    state.compensation.compensation_type = compensation_type
    state.compensation.compensable = compensable
    state.compensation.which_law = which_law
  },

  GET_COMMPENSATION_IMPOSSIBLE(state, payload) {
    console.log(payload);
    let {currency, amount, errors, compensable} = payload
    console.log(errors);
    state.compensation.amount = amount
    state.compensation.currency = currency
    state.compensation.compensable = compensable
    state.compensation.errors = Object.values(errors)
  },

  INIT_EDITING(state, value) {
    state.editing = value
    state.eComplaint = JSON.parse(JSON.stringify(state.complaint))
  },

  CANCEL_EDITING(state) {
    state.editing = false
    state.eComplaint = {}
  },

  APPLY_EDITING(state) {
    state.editing = false
    state.complaint = {...state.complaint, ...state.eComplaint}
    state.eComplaint = {}
  },

  FETCH_RECEIPT(state, payload) {
    state.receipt.id = payload.complaint.id
    state.receipt.authorization_key = payload.complaint.authorization.uploads_key
    state.receipt.domain = payload.complaint.domain
    state.receipt.source_origin = payload.complaint.source_origin
    // TODO reset first round
    // TODO fix reset poa
  }
}

const getters = {

  getField,

  getComplaintField(state) {
    return getField(state.editing ? state.eComplaint : state.complaint)
  },

  totalCompensation: (state, getters) => {
    return state.compensation.amount * getters.getComplaintField('people')
  },

  totalCompensationEur: (state, getters) => {
    return state.compensation.amount_in_eur * getters.getComplaintField('people')
  },

  caseId: (state) => {
    return state.receipt.id
  },

  currencySymbol: (state) => {
    let currency = state.compensation.currency
    switch(currency) {
      case 'DKK': return "kr";
      case 'EUR': return "€";
      case 'CZK': return "Kč";
      case 'PLN': return "zł";
      case 'NOK': return "kr";
      case 'GBP': return "£";
      case 'TRY': return "₺";
      case 'SEK': return "kr";
      case 'CAD': return "$";
    }
  },

  kindMapper: () => {
    return {
      delayed: i18n.t('f_kind_delayed'),
      cancelled: i18n.t('f_kind_cancelled'),
      overbooked: i18n.t('f_kind_overbooked'),
      corona: i18n.t('f_kind_corona'),
      early: i18n.t('f_early_flight_button')
    }
  },

  informedEarlyFlightsMapper: () => {
    return {
      3: i18n.t('f_more_14_days_before_departure'),
      2: i18n.t('f_between_7_and_14_days_before_departure'),
      1: i18n.t('f_between_0_and_7_days_before_departure'),
    }
  },

  delaysEarly714DaysMapper: () => {
    return {
      '-121': i18n.t('f_moved_more_2_hours_earlier'),
      '-119': i18n.t('f_moved_0_2_hours_earlier'),
      '239': i18n.t('f_moved_0_4_hours_later'),
      '241': i18n.t('f_moved_more_4_hours_later')
    }
  },

  delaysEarly7DaysMapper: () => {
    return {
      '-61': i18n.t('f_moved_more_1_hours_earlier'),
      '-59': i18n.t('f_moved_0_1_hours_earlier'),
      '119': i18n.t('f_moved_0_2_hours_later'),
      '121': i18n.t('f_moved_more_2_hours_later')
    }
  },

  delaysMapperWithCorona: () => {
    return {
      118: i18n.t('f_less_then', ['2']),
      120: i18n.t('f_delay_option', ['2-3']),
      180: i18n.t('f_delay_option', ['3-4']),
      240: i18n.t('f_delay_option', ['4-5']),
      300: i18n.t('f_delay_option', ['5-6']),
      360: i18n.t('f_delay_option', ['6-7']),
      420: i18n.t('f_delay_option', ['7-8']),
      480: i18n.t('f_delay_option', ['8-9']),
      540: i18n.t('f_delay_option', ['9-10']),
      600: i18n.t('f_delay_option', ['10-11']),
      660: i18n.t('f_delay_option', ['11-12']),
      720: i18n.t('f_more_then', ['12']),
      "flight_was_cancelled_and_i_chose_voluntarily_not_to_fly": i18n.t('f_cancelled_volunteer_no_fly'),
      "i_did_not_go__since_the_airline_refused_to_rebook_me__even_though_there_was_other_options": i18n.t('f_cancelled_nofly_norebook'),
      "flight_was_not_cancelled__but_i_chose_voluntarily_not_to_fly": i18n.t('f_notcancelled_volunteer_no_fly'),
      "i_did_not_fly__since_there_was_no_other_flights_available__that_made_sense": i18n.t('f_cancelled_nofly_noflights'),
    }
  },

  delaysMapperDelayedWithMissedConnection: () => {
    return {
      118: i18n.t('f_less_then', ['2']),
      119: i18n.t('f_less_than_3_but_missed_connection'),
      120: i18n.t('f_delay_option', ['2-3']),
      180: i18n.t('f_delay_option', ['3-4']),
      240: i18n.t('f_delay_option', ['4-5']),
      300: i18n.t('f_delay_option', ['5-6']),
      360: i18n.t('f_delay_option', ['6-7']),
      420: i18n.t('f_delay_option', ['7-8']),
      480: i18n.t('f_delay_option', ['8-9']),
      540: i18n.t('f_delay_option', ['9-10']),
      600: i18n.t('f_delay_option', ['10-11']),
      660: i18n.t('f_delay_option', ['11-12']),
      720: i18n.t('f_more_then', ['12']),
      1440: i18n.t('f_i_chose_not_to_fly'),
    }
  },

  delaysMapperRegular: () => {
    return {
      118: i18n.t('f_less_then', ['2']),
      120: i18n.t('f_delay_option', ['2-3']),
      180: i18n.t('f_delay_option', ['3-4']),
      240: i18n.t('f_delay_option', ['4-5']),
      300: i18n.t('f_delay_option', ['5-6']),
      360: i18n.t('f_delay_option', ['6-7']),
      420: i18n.t('f_delay_option', ['7-8']),
      480: i18n.t('f_delay_option', ['8-9']),
      540: i18n.t('f_delay_option', ['9-10']),
      600: i18n.t('f_delay_option', ['10-11']),
      660: i18n.t('f_delay_option', ['11-12']),
      720: i18n.t('f_more_then', ['12']),
      1440: i18n.t('f_i_chose_not_to_fly'),
    }
  },

  delaysMapperForEarlyFlight: () => {
    return {
      '-59': i18n.t('f_less_then', ['1']),
      '-119': i18n.t('f_early_option', ['1-2']),
      '-179': i18n.t('f_early_option', ['2-3']),
      '-239': i18n.t('f_early_option', ['3-4']),
      '-241': i18n.t('f_early_option_max', ['4']),
    }
  },

  reasonsMapper: () => {
    return [
      { value: '', title: i18n.t('f_reason_placeholder') }, // Please select
      { value: 4, title: i18n.t('f_reason_11') }, // Technical problems
      { value: 7, title: i18n.t('f_reason_12') }, // Adverse weather conditions
      { value: 9, title: i18n.t('f_reason_19') }, // Delay of previous flight
      { value: 1, title: i18n.t('f_reason_15') }, // Illness among passengers
      { value: 6, title: i18n.t('f_reason_14') }, // Illness among flight crew
      { value: 12, title: i18n.t('f_reason_16') }, // Airline strike
      { value: 8, title: i18n.t('f_reason_17') }, // Other strike
      { value: 13, title: i18n.t('f_reason_18') }, // Airplane hit by bird or other object
      { value: 11, title: i18n.t('f_reason_13') }, // The airport was closed down due to security reasons
      { value: 14, title: i18n.t('f_reason_20') }, // Other
      { value: 10, title: i18n.t('f_reason_21') } // I don’t know the reason
    ]
  },

  selectedReasonTitle: (state, getters) => {
    return getters.reasonsMapper.find((reason) => {
      return reason['value'] == state.complaint.reason
    })['title']
  },

  countriesMapper: (state) => {
    return state.countriesCodes.reduce((mapper, code) => {
      mapper.push({ 'code': code, 'value': i18n.t(`f_country_${code}`) })
      return mapper
    }, []).sort((a,b) => a.value.localeCompare(b.value) )
  },

  selectedCountryTitle: (state, getters) => {
    return getters.countriesMapper.find((country) => {
      return country['code'] == state.complaint.macda_country_id
    })['value']
  },

  defaultCountry: (state, getters, rootState) => {
    let def, locale = rootState.locale
    switch(locale){
      case 'pl': def = 'PL'; break;
      case 'cz': def = 'CZ'; break;
      case 'en': def = 'GB'; break;
      case 'tr': def = 'TR'; break;
      case 'se': def = 'SE'; break;
      case 'dk': def = 'DK'; break;
      case 'no': def = 'NO'; break;
      case 'fi': def = 'FI'; break;
      case 'de': def = 'DE'; break;
      case 'ca': def = 'CA'; break;
      default: def = 'DK'
    }
    return def
  },

  defaultCurrency: (state, getters, rootState) => {
    let cur, locale = rootState.locale
    switch(locale) {
      case 'pl': cur = "EUR"; break;
      case 'dk': cur = "DKK"; break;
      case 'fi': cur = "EUR"; break;
      case 'se': cur = "EUR"; break;
      case 'no': cur = "NOK"; break;
      case 'cz': cur = "EUR"; break;
      case 'en': cur = "GBP"; break;
      case 'de': cur = "EUR"; break;
      case 'ca': cur = "CAD"; break;
      case 'tr': cur = "TRY"; break;
    }
    return cur
  },

  r1ComplaintFormData: (state) => {
    let formData = new FormData()
    let {year, month, date, hours, minutes} = state.complaint.scheduled_arrival_at_ui_date_time

    if (state.complaint.source_origin) {
      formData.append('complaint[source_origin]', state.complaint.source_origin)
    }
    if (state.complaint.tduid) {
      formData.append('complaint[tduid]', state.complaint.tduid)
    }
    formData.append('complaint[macda_departure_airport_id]', state.complaint.departure_airport.id)
    formData.append('complaint[macda_arrival_airport_id]', state.complaint.arrival_airport.id)
    //formData.append('complaint[airline_id]', 526) // TODO fix
    formData.append('complaint[flight_number]', state.complaint.flight_number)
    
    if(year && hours){
      formData.append('complaint[scheduled_arrival_at]', 
        moment().year(year).month(month - 1).date(date).hours(hours).minutes(minutes).format('YYYY-MM-DDTHH:mm'))
    }
    formData.append('complaint[kind]', state.complaint.kind)
    formData.append('complaint[delay]', state.complaint.delay)
    formData.append('complaint[reason]', state.complaint.reason)
    formData.append('complaint[people]', state.complaint.people)
    formData.append('complaint[comment]', state.complaint.comment)
    formData.append('complaint[compensation_amount]', state.compensation.amount_in_eur)
    formData.append('complaint[name]', state.complaint.name)
    formData.append('complaint[address]', state.complaint.address)
    formData.append('complaint[zip_code]', state.complaint.zip_code)
    formData.append('complaint[city]', state.complaint.city)
    formData.append('complaint[country]', state.complaint.macda_country_id)
    formData.append('complaint[email]', state.complaint.email)
    formData.append('complaint[terms]', state.complaint.terms)
    formData.append('complaint[insurance_number]', state.complaint.insurance_number)
    formData.append('complaint[client_informed]', state.complaint.client_informed)
    if (state.complaint.next_flight_number) {
      formData.append('complaint[next_flight_number]', state.complaint.next_flight_number)
    }
    return formData
  }
}

export default {
  namespaced: true,
  state: defaultState,
  actions: actions,
  mutations: mutations,
  getters: getters
}
